import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { readBlobAsBase64 } from '@capacitor/core/types/core-plugins';
import { Observable, ReplaySubject, from, isEmpty } from 'rxjs';
import { Categoria } from 'src/app/model/categoria';
import { Marca } from 'src/app/model/marca';
import { CategoriaService } from 'src/app/services/api/categoria.service';
import { MarcaService } from 'src/app/services/api/marca.service';
import { ProductoService } from 'src/app/services/api/producto.service';
import { environment } from 'src/environments/environment';
import { v4 as uuid } from 'uuid';
import { DomSanitizer } from '@angular/platform-browser';
import { ColorService } from 'src/app/services/api/color.service';
import { Color } from 'src/app/model/color';
import { TallaService } from 'src/app/services/api/talla.service';
import { Talla } from 'src/app/model/talla';
import { ColorTallaDTO } from 'src/app/model/colortallaDTO';
import { ProductosDTO } from 'src/app/model/productosDTO';
import { ProductoDTOService } from 'src/app/services/api/productoDTO.service';
import { stockDTO } from 'src/app/model/stockDTO';
import { TipoTalla } from 'src/app/model/tipoTalla';
import { TipoTallaService } from 'src/app/services/api/tipoTalla.service';
import { TokenStorageService } from 'src/app/services/api/TokenStorageService';
import { ProductoRelacionadoDTO } from 'src/app/model/productoRelacionadoDTO';

declare let $: any;
@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.css']
})
export class ProductoComponent implements OnInit {
  @ViewChild('myModal')myModal!: ElementRef;
  @ViewChild('myModal2')myModal2!: ElementRef;
  formProducto!: FormGroup;
  formProducto2!: FormGroup;
  form = new FormData();
  form2 = new FormData();
  form3 = new FormData();
   url : string = `${environment.HOST}/api/media/`;
   urlServerUpload$ : string = `${environment.HOST}/api/media/`;
   tipoMedia$ : String = "/0";
   nombreArchivo:String="";
   nombreArchivo2:String="";
   nombreArchivo3:String="";
   categoria:Categoria[]=[];
   marca:Marca[]=[];
   color:Color[]=[];
   talla:Talla[]=[];
   fileName:String="";
   fileName2:String="";
   fileName3:String="";
   fileExtension:String="";
   fileExtension2:String="";
   fileExtension3:String="";
   nombreArchivoFull:String="";
   nombreArchivoFull2:String="";
   nombreArchivoFull3:String="";
   imagenPrevia: any;
   previsualizacion:String="";
   imagenRel:String="";
   modeloRel:String="";
   previsualizacion2:String="";
   previsualizacion3:String="";
   colortalladto:ColorTallaDTO[]=[];
   productoRel:ProductoRelacionadoDTO[]=[];
   colorSeleccionado:String="";
   tallaSeleccionado:String="";
   valorColorSeleccionado:String="";
   IdProducto:number=0;
   tempcolortalla:String="";
   temproductorel:String="";
   esperar:boolean=false;
   i:number=-1;
   j:number=-1;
   stockdto:stockDTO[]=[];
   productodto:ProductosDTO[]=[];
   txtBuscar:string="";
   tipotalla:TipoTalla[]=[];
   errorForm2:String[]=["0","0","0"];
   errorForm:String[]=["0","0","0","0"];
   accion:number=0;
   idProductoDTO:number=0;
   tituloBotonGuardar:String="Nuevo Registro";
   idUsrDTO:number=0;
   copiar:number=0;
   tituloBotonSelect:string="";
   mostrarButtonEliminar:boolean=false;
  constructor(
    private http : HttpClient,
    private categoriaService : CategoriaService,
    private productoService:ProductoService,
    private marcaService : MarcaService,
    private sanitizer: DomSanitizer,
    private colorService : ColorService,
    private tallaService : TallaService,
    private productoDTOService : ProductoDTOService,
    private tipoTallaService : TipoTallaService,
    private tokenStorage: TokenStorageService
  ) { }

  ngOnInit(): void {


  
    this.formProducto = new FormGroup({
      'txtDescripcion' : new FormControl('', Validators.required),
      'txtModelo' : new FormControl('', Validators.required),
      'txtDetalles' : new FormControl('', Validators.required),
      'cmbCategoria' : new FormControl('', Validators.required),
      'cmbMarca' : new FormControl('', Validators.required),
      'txtPrecio' : new FormControl('', Validators.required),
      'txtPrecio2' : new FormControl('', Validators.required),
      'txtAltura' : new FormControl('', Validators.required),
      'cmbEstado' : new FormControl('', Validators.required),
      'cmbLimitarExistencia' : new FormControl('', Validators.required)
    });

    this.formProducto2 = new FormGroup({
     
      'cmbColor' : new FormControl('', Validators.required),
      'cmbTalla' : new FormControl('', Validators.required),
      'cmbTipoTalla' : new FormControl('', Validators.required),
     
    });
  
    if (this.tokenStorage.getToken()!==null) {
      let json = JSON.stringify(this.tokenStorage.getUser());
       let data=JSON.parse(json.toString());
      
      this.idUsrDTO=data.idUsuario;
        }


    
    this.OnGetCategoria(); 
    this.OnGetMarca(); 
    this.OnGetColor();
    this.OnGetTipoTalla();



      }
  
  onFileSelected(event:any){
    this.nombreArchivo="";
    const file:File = event.target.files[0] ;
   
     this.fileName =  uuid(); //get name from form for example
     this.fileExtension = file.name.split('?')[0].split('.').pop()+"";
  
    this.form.append("files",  event.target.files[0],this.fileName+'.'+ this.fileExtension);
   

  this.nombreArchivo=this.fileName+'.'+ this.fileExtension;
  
  this.blobFile(file).then((imagen : any)=>{
    this.previsualizacion=imagen.base;
    console.log(imagen);
  })
 

  }


  onFileSelected2(event:any){
    this.nombreArchivo2="";
    const file:File = event.target.files[0] ;
   
     this.fileName2 =  uuid(); //get name from form for example
     this.fileExtension2 = file.name.split('?')[0].split('.').pop()+"";
  
    this.form2.append("files",  event.target.files[0],this.fileName2+'.'+ this.fileExtension2);
   

  this.nombreArchivo2=this.fileName2+'.'+ this.fileExtension2;
  
  this.blobFile(file).then((imagen : any)=>{
    this.previsualizacion2=imagen.base;
    console.log(imagen);
  })
 

  }


  onFileSelected3(event:any){
    this.nombreArchivo3="";
    const file:File = event.target.files[0] ;
   
     this.fileName3 =  uuid(); //get name from form for example
     this.fileExtension3 = file.name.split('?')[0].split('.').pop()+"";
  
    this.form3.append("files",  event.target.files[0],this.fileName3+'.'+ this.fileExtension2);
   

  this.nombreArchivo3=this.fileName3+'.'+ this.fileExtension3;
  
  this.blobFile(file).then((imagen : any)=>{
    this.previsualizacion3=imagen.base;
    console.log(imagen);
  })
 

  }



  getProductosDTOByEstadoModelo(idEstado:number,modelo:string){
    this.productoDTOService.getProductosDTOByEstadoAndModelo( idEstado,modelo).subscribe(response =>{
      console.log(response)
      return this.productodto=response
    })
  }


  blobFile = async ($event: any) => new Promise((resolve, reject): null | void => {
    try {
      const unsafeImg = window.URL.createObjectURL($event);
      const image = this.sanitizer.bypassSecurityTrustUrl(unsafeImg);
      const reader = new FileReader();
      reader.readAsDataURL($event);
      reader.onload = () => {
        resolve({
          base: reader.result
        });
      };
      reader.onerror = error => {
        resolve({
          base: null
        });
      };

    } catch (e) {
      return null;
    }
  })



ValidarFormColores(){
let rs:number=0;
let r1:number=0;
let r2:number=0;
let r3:number=0;

if ((parseInt(this.formProducto2.value['cmbColor'])) >0) {
  this.errorForm2[0]="0";
r1=0;
}else 
{
  r1=1;
  this.errorForm2[0]="1";
}

if ((parseInt(this.formProducto2.value['cmbTipoTalla'])) >0) {
  this.errorForm2[1]="0";
  r2=0;
  }else{
    this.errorForm2[1]="1";
    r2=1;
  }
  
  if ((parseInt(this.formProducto2.value['cmbTalla'])) >0) {
    r3=0;
    this.errorForm2[2]="0";
    }else{
      this.errorForm2[2]="1";
      r3=1;
    }

    rs=r1+r2+r3;

return rs;
}


  OnAgregarColorTalla(){
   
if (this.ValidarFormColores()==0) {

  let continuar:boolean=true;
// verificar que no exista 
for (let listActual of this.colortalladto){

  if (listActual.idColor==this.formProducto2.value['cmbColor'] && listActual.idTalla==this.formProducto2.value['cmbTalla'] ){

    continuar=false;
    break;
  }

}


if (continuar==true){
  this.i++;
  const lista: ColorTallaDTO= {
    indice:this.i,
    idProducto:this.IdProducto,
    idColor:this.formProducto2.value['cmbColor'],
    idTalla:this.formProducto2.value['cmbTalla'],
    idEstado:0,
    color:this.colorSeleccionado,
    talla:this.tallaSeleccionado,
    codigoColor:this.valorColorSeleccionado
  
  }
  


  this.colortalladto.push(lista);
  let json = JSON.stringify(lista);
  

  
  if (this.i==0){ 
    this.tempcolortalla=this.tempcolortalla+json.replace('#','');
  }
  if (this.i>0){ 
    this.tempcolortalla=this.tempcolortalla+',,'+json.replace('#','');
  }
   
 

}else {

  alert("YA EXISTE EL COLOR Y TALLA");
}



  

}


console.log(this.tempcolortalla)


}






OnEliminarLista2(indices:number){
  console.log("eliminar:"+indices)
let xindice:number=0;
   for (let lista of this.productoRel){
   
if (lista.indice==indices){

  break;
}
xindice++;
}

   this.productoRel.splice(xindice,1);
   this.temproductorel="";
  for (let lista of this.productoRel){
    let json = JSON.stringify(lista);
    if (lista.indice==0){ 
      this.temproductorel=this.temproductorel+json.replace('#','');
    }
    if (lista.indice>0){ 
      this.temproductorel=this.temproductorel+',,'+json.replace('#','');
    }
this.j=lista.indice;
  }

}








OnEliminarLista(indices:number){
  console.log("eliminar:"+indices)
let xindice:number=0;
   for (let lista of this.colortalladto){
   
if (lista.indice==indices){

  break;
}
xindice++;
}

   this.colortalladto.splice(xindice,1);
   this.tempcolortalla="";
  for (let lista of this.colortalladto){
    let json = JSON.stringify(lista);
    if (lista.indice==0){ 
      this.tempcolortalla=this.tempcolortalla+json.replace('#','');
    }
    if (lista.indice>0){ 
      this.tempcolortalla=this.tempcolortalla+',,'+json.replace('#','');
    }
this.i=lista.indice;
  }

}

OnSelectColor(){
  for (let lista of this.color){
    if (lista.idColor==this.formProducto2.value['cmbColor']){
      this.colorSeleccionado=lista.descripcion+"";
      this.valorColorSeleccionado=lista.valorColor+"";
     
      break;
    }

}
}














OnSeleccionarProducto(idproducto:any){



 
 switch (this.copiar){


  case 1:

    this.idProductoDTO=idproducto;
  this.productoDTOService.getProductosDTOById( this.idProductoDTO).subscribe(response =>{
    for(let dato of response) {
   
      this.formProducto.controls['txtModelo'].setValue(dato.modelo);
      this.formProducto.controls['txtDescripcion'].setValue(dato.descripcion);
      this.formProducto.controls['txtDetalles'].setValue(dato.detalles);
      this.formProducto.controls['txtPrecio'].setValue(dato.precio);
      this.formProducto.controls['txtPrecio2'].setValue(dato.precio2);
      this.formProducto.controls['cmbCategoria'].setValue(dato.idCategoria);
      this.formProducto.controls['cmbMarca'].setValue(dato.idMarca);
      this.formProducto.controls['txtAltura'].setValue(dato.altura);
      this.formProducto.controls['cmbEstado'].setValue(dato.idEstado);
    //  if (dato.limitarExistencia=='NO'){this.formProducto.controls['cmbLimitarExistencia'].setValue(1);}
    //  if (dato.limitarExistencia=='SI'){this.formProducto.controls['cmbLimitarExistencia'].setValue(2);}
    this.formProducto.controls['cmbLimitarExistencia'].setValue(dato.limitarExistencia);
      this.previsualizacion=this.url+dato.imagen+"/0";
      this.previsualizacion2=this.url+dato.imagen2+"/0";
      this.previsualizacion3=this.url+dato.imagen3+"/0";
      this.accion=1;
      this.tituloBotonGuardar="Modificar Registro";
      this.mostrarButtonEliminar=true;
    }
  });



  this.OnGetColorTalla(this.idProductoDTO);

this.OnGetProductoRelacionadoByIdProducto(this.idProductoDTO);


  break;

  case 2:



  this.productoDTOService.getProductosDTOById(idproducto).subscribe(response =>{
    for(let dato of response) {
    
    this.OnAgregarProductoRelacionado(idproducto,dato.modelo+"",dato.imagen+"");
    }
  });





  break;

 }

    

  $(this.myModal.nativeElement).modal('hide'); 

}


OnAgregarProductoRelacionado(_idproducto:number,_modelo:string,_imagen:string){

  this.j++;
  const listarel: ProductoRelacionadoDTO= {
    indice:this.j,
    idProductoOrigen:0,
    idProducto:_idproducto,
    modelo:_modelo,
    imagen:_imagen,
    descripcion:"VARIOS",
    precio:0,

  
  }
  
  this.productoRel.push(listarel);
  let json = JSON.stringify(listarel);

  if (this.j==0){ 
    this.temproductorel=this.temproductorel+json.replace('#','');
  }
  if (this.j>0){ 
    this.temproductorel=this.temproductorel+',,'+json.replace('#','');
  }
 

  console.log(this.temproductorel);


}


OnBuscarPorModelo(){

console.log(this.txtBuscar)
this.getProductosDTOByEstadoModelo(0,this.txtBuscar);
}


OnAbrirConfirmacion(){

  $(this.myModal2.nativeElement).modal('show'); 
}

OnAbrirBusqueda(){
  this.txtBuscar="";
this.copiar=1;
this.tituloBotonSelect="Editar"
this.productodto=[];
  $(this.myModal.nativeElement).modal('show'); 

}

OnAbrirBusqueda2(){
  this.txtBuscar="";
  this.copiar=2;
  this.tituloBotonSelect="Agregar"
  this.productodto=[];
    $(this.myModal.nativeElement).modal('show'); 
  
  }


OnSelectTalla(){


  for (let lista of this.talla){
    if (lista.idTalla==this.formProducto2.value['cmbTalla']){
      this.tallaSeleccionado=lista.descripcion+"";
      break;
    }

}
}


OnTallaByTipoTalla(){


this.tallaService.getTallabyTipoTalla( parseInt(this.formProducto2.value['cmbTipoTalla'])).subscribe(response =>{
  console.log(response)
  return this.talla=response
})
 
}



ValidarModificaRegistro(){
  let rs:number=0;
  let r1:number=0;
  let r2:number=0;
  let r3:number=0;
  let r4:number=0;
  let r5:number=0;
  let r6:number=0;
  let r7:number=0;
  let r8:number=0;
  let r9:number=0;
  let r10:number=0;
  let r11:number=0;

  if (this.previsualizacion!==""){
    this.errorForm[0]="0";
    r1= 0;
  }else {
    this.errorForm[0]="1";
    r1= 1;
  }

  if (this.previsualizacion2!==""){
    this.errorForm[1]="0";
    r2= 0;
  }else {
    this.errorForm[1]="1";
    r2= 1;
  }

  if (this.previsualizacion3!==""){
    this.errorForm[2]="0";
    r3= 0;
  }else {
    this.errorForm[2]="1";
    r3= 1;
  }

  if (this.formProducto.value['txtModelo']!==""){
    this.errorForm[3]="0";
    r4= 0;
  }else {
    this.errorForm[3]="1";
    r4= 1;
  }


  if (this.formProducto.value['txtDescripcion']!==""){
    this.errorForm[4]="0";
    r5= 0;
  }else {
    this.errorForm[4]="1";
    r5= 1;
  }


  if (this.formProducto.value['txtDetalles']!==""){
    this.errorForm[5]="0";
    r6= 0;
  }else {
    this.errorForm[5]="1";
    r6= 1;
  }


  if (this.formProducto.value['cmbCategoria']>0){
    this.errorForm[6]="0";
    r7= 0;
  }else {
    this.errorForm[6]="1";
    r7= 1;
  }

  if (this.formProducto.value['cmbMarca']>0){
    this.errorForm[7]="0";
    r8= 0;
  }else {
    this.errorForm[7]="1";
    r8= 1;
  }


  if (this.formProducto.value['txtPrecio']!=="" && this.formProducto.value['txtPrecio']>0 ){
    this.errorForm[8]="0";
    r9= 0;
  }else {
    this.errorForm[8]="1";
    r9= 1;
  }


  if (this.formProducto.value['txtPrecio2']!=="" && this.formProducto.value['txtPrecio2']>=0 ){
    this.errorForm[9]="0";
    r10= 0;
  }else {
    this.errorForm[9]="1";
    r10= 1;
  }

  if (this.formProducto.value['txtAltura']!=="" ){
    this.errorForm[10]="0";
    r11= 0;
  }else {
    this.errorForm[10]="1";
    r11= 1;
  }

  rs=r1+r2+r3+r4+r5+r6+r7+r8+r9+r10+r11;

return rs;

}


ValidarNuevoRegistro(){
let rs:number=0;

let r1:number=0;
let r2:number=0;
let r3:number=0;
let r4:number=0;
let r5:number=0;
let r6:number=0;
let r7:number=0;
let r8:number=0;
let r9:number=0;
let r10:number=0;
let r11:number=0;
let r12:number=0;

  if (this.previsualizacion!==""){
    this.errorForm[0]="0";
    r1= 0;
  }else {
    this.errorForm[0]="1";
    r1= 1;
  }

  if (this.previsualizacion2!==""){
    this.errorForm[1]="0";
    r2= 0;
  }else {
    this.errorForm[1]="1";
    r2= 1;
  }

  if (this.previsualizacion3!==""){
    this.errorForm[2]="0";
    r3= 0;
  }else {
    this.errorForm[2]="1";
    r3= 1;
  }

  if (this.formProducto.value['txtModelo']!==""){
    this.errorForm[3]="0";
    r4= 0;
  }else {
    this.errorForm[3]="1";
    r4= 1;
  }


  if (this.formProducto.value['txtDescripcion']!==""){
    this.errorForm[4]="0";
    r5= 0;
  }else {
    this.errorForm[4]="1";
    r5= 1;
  }


  if (this.formProducto.value['txtDetalles']!==""){
    this.errorForm[5]="0";
    r6= 0;
  }else {
    this.errorForm[5]="1";
    r6= 1;
  }


  if (this.formProducto.value['cmbCategoria']>0){
    this.errorForm[6]="0";
    r7= 0;
  }else {
    this.errorForm[6]="1";
    r7= 1;
  }

  if (this.formProducto.value['cmbMarca']>0){
    this.errorForm[7]="0";
    r8= 0;
  }else {
    this.errorForm[7]="1";
    r8= 1;
  }


  if (this.formProducto.value['txtPrecio']!=="" && this.formProducto.value['txtPrecio']>0 ){
    this.errorForm[8]="0";
    r9= 0;
  }else {
    this.errorForm[8]="1";
    r9= 1;
  }


  if (this.formProducto.value['txtPrecio2']!=="" && this.formProducto.value['txtPrecio2']>=0 ){
    this.errorForm[9]="0";
    r10= 0;
  }else {
    this.errorForm[9]="1";
    r10= 1;
  }

  if (this.formProducto.value['txtAltura']!=="" ){
    this.errorForm[10]="0";
    r11= 0;
  }else {
    this.errorForm[10]="1";
    r11= 1;
  }


  if (this.formProducto.value['cmbEstado']>0){
    this.errorForm[11]="0";
    r12= 0;
  }else {
    this.errorForm[11]="1";
    r12= 1;
  }


  rs=r1+r2+r3+r4+r5+r6+r7+r8+r9+r10+r11+r12;


return rs;
}




OnGetColorTalla(idproducto:any){
  this.productoDTOService.getStockByProducto(idproducto).subscribe(response =>{
 
    for(let dato of response) {
      this.i++;

      const lista: ColorTallaDTO= {
        indice:this.i,
        idProducto:parseInt(dato.idProducto+""),
        idColor:parseInt(dato.idColor+""),
        idTalla:parseInt(dato.idTalla+""),
        idEstado:0,
        color:dato.color+"",
        talla:dato.talla+"",
        codigoColor:dato.valorColor+""
    }
    this.colortalladto.push(lista);

    let json = JSON.stringify(lista);
  

  
    if (this.i==0){ 
      this.tempcolortalla=this.tempcolortalla+json.replace('#','');
    }
    if (this.i>0){ 
      this.tempcolortalla=this.tempcolortalla+',,'+json.replace('#','');
    }



  }


  console.log("indice :"+this.i);


  });

     
   // alert(this.tempcolortalla);

}


OnGetProductoRelacionadoByIdProducto(idproducto:any){
  this.productoDTOService.getProductoRelacionadoByIdProducto(idproducto).subscribe(response =>{
 
    for(let dato of response) {
      this.j++;

      const lista: ProductoRelacionadoDTO= {
        indice:this.j,
        idProductoOrigen:parseInt(dato.idProductoOrigen+""),
        idProducto:parseInt(dato.idProducto+""),
        precio:dato.precio,
        descripcion:dato.descripcion+"",
        modelo:dato.modelo,
        imagen:dato.imagen+""
    }
    this.productoRel.push(lista);

    let json = JSON.stringify(lista);
  

  
    if (this.j==0){ 
      this.temproductorel=this.temproductorel+json.replace('#','');
    }
    if (this.j>0){ 
      this.temproductorel=this.temproductorel+',,'+json.replace('#','');
    }
     
 


  }


  console.log("indice :"+this.j);
console.log(this.temproductorel.toString());

  });
}



OnAnulaProducto(){

  switch (this.accion) {
    case 1:
      if (this.idProductoDTO>0){
        $(this.myModal2.nativeElement).modal('hide'); 
        this.productoService.anulaProducto(this.idUsrDTO,this.idProductoDTO).subscribe(response =>{
         console.log(response);
      
         alert("Producto Anulado!!!");
      window.location.reload();
         });
      }
    break;
  }
}



OnGuardarProducto(){


switch (this.accion) {
case 0:
  if (this.ValidarNuevoRegistro()==0 && this.tempcolortalla!==null ){

    this.esperar=true;
    this.productoService.nuevoProducto(
      this.idUsrDTO,
      this.formProducto.value['txtModelo'],
    this.formProducto.value['txtDescripcion'],
    this.formProducto.value['txtDetalles'],
    parseInt(this.formProducto.value['cmbCategoria']) ,
    parseInt(this.formProducto.value['cmbMarca']),
    parseFloat(this.formProducto.value['txtPrecio']),
    this.fileName+'.'+ this.fileExtension,  
    this.tempcolortalla,
    this.fileName2+'.'+ this.fileExtension2,  
    this.fileName3+'.'+ this.fileExtension3,
    parseFloat(this.formProducto.value['txtPrecio2']),
    this.formProducto.value['txtAltura'],
    this.formProducto.value['cmbEstado'],
    this.formProducto.value['cmbLimitarExistencia']).subscribe(response =>{
      console.log(response)
   if (response.toString()!="0"){
   
     if (this.previsualizacion!==null){
      
   
       this.OnGuardarImagenPortada();
   
     }
    
     if (this.previsualizacion2!==null){
       this.OnGuardarImagenPortada2();
     }
   
     if (this.previsualizacion3!==null){
       this.OnGuardarImagenPortada3();
     }
   
     this.esperar=false;


   }else{
   
     if (response.toString()=="0"){
       this.esperar=false;
     }
   
   }
    
      
      
      alert("Producto Registrado!!!");
      window.location.reload();
   
    
    })
  
  }
break;

case 1:

  if (this.ValidarModificaRegistro()==0 && this.tempcolortalla!==null ){
console.log(this.nombreArchivo)





if (this.fileName==""){

  this.nombreArchivoFull="null";
}else {
  this.nombreArchivoFull=this.nombreArchivo;
}
if (this.fileName2==""){
  this.nombreArchivoFull2="null";
  
}else { this.nombreArchivoFull2=this.nombreArchivo2;}
if (this.fileName3==""){
  this.nombreArchivoFull3="null";
  
}else { this.nombreArchivoFull3=this.nombreArchivo3;}

if (this.temproductorel==""){
this.temproductorel="null";
}




    this.esperar=true;

    console.log("archivo:"+this.nombreArchivo);

//if (this.nombreArchivo!==""){
//  this.OnGuardarImagenPortada();
//}
    console.log("relacionados:"+this.temproductorel+"" )


      this.productoService.modificaProducto(
        this.idUsrDTO,
      this.idProductoDTO,
      this.formProducto.value['txtModelo'],
    this.formProducto.value['txtDescripcion'],
    this.formProducto.value['txtDetalles'],
    parseInt(this.formProducto.value['cmbCategoria']) ,
    parseInt(this.formProducto.value['cmbMarca']),
    parseFloat(this.formProducto.value['txtPrecio']),
    this.nombreArchivoFull,  
    this.tempcolortalla,
   this.nombreArchivoFull2,  
    this.nombreArchivoFull3,
    parseFloat(this.formProducto.value['txtPrecio2']),
    this.formProducto.value['txtAltura'],
    this.formProducto.value['cmbEstado'],
    this.temproductorel+"",
    this.formProducto.value['cmbLimitarExistencia']).subscribe(response =>{
      console.log(response)
   if (response.toString()!="0"){
    //alert("ay imagen neuva");
     if (this.nombreArchivo!==""){

   
       this.OnGuardarImagenPortada();
   
     }
    
     if (this.nombreArchivo2!==""){
       this.OnGuardarImagenPortada2();
     }
   
     if (this.nombreArchivo3!==""){
       this.OnGuardarImagenPortada3();
     }

     this.esperar=false;

   }else{
   
     if (response.toString()=="0"){
       this.esperar=false;
     }
   
   }
    
      
      
      alert("Producto Modificado!!!");
      window.location.reload();
   
    
    })
  }
break;
}






}
OnGetCategoria(){
  this.categoriaService.getCategoria().subscribe(response =>{
    console.log(response)
    return this.categoria=response
  })
}

OnGetMarca(){
  this.marcaService.getMarca().subscribe(response =>{
    console.log(response)
    return this.marca=response
  })
}

OnGetColor(){
  this.colorService.getColor().subscribe(response =>{
    console.log(response)
    return this.color=response
  })
}


OnGetTalla(){
  this.tallaService.getTalla().subscribe(response =>{
    console.log(response)
    return this.talla=response
  })
}


OnGetTipoTalla(){
  this.tipoTallaService.getTipoTalla().subscribe(response =>{
    console.log(response)
    return this.tipotalla=response
  })
}



  OnGuardarImagenPortada(){
try{
  this.productoService.guardarImagenPortada(this.form,0).subscribe(response=>{
    console.log("servidor:",response)
    })
}catch(e){
console.log("ERROR: ",e);
}
}


OnGuardarImagenPortada2(){
  try{
    this.productoService.guardarImagenPortada(this.form2,0).subscribe(response=>{
      console.log("servidor:",response)
      })
  }catch(e){
  console.log("ERROR: ",e);
  }
  }

  OnGuardarImagenPortada3(){
    try{
      this.productoService.guardarImagenPortada(this.form3,0).subscribe(response=>{
        console.log("servidor:",response)
        })
    }catch(e){
    console.log("ERROR: ",e);
    }
    }



}



